import React, { useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import AdminProductMenu from "./AdminProductMenu";
import { selectCatalogItem, getAdminCatalogItem, selectOtherCatalogItems, addColor } from '../../reducers/subsite';
import { addToCart, cartCount } from '../../reducers/cart';
import { isLoggedIn } from '../../reducers/auth';
import { useLocation } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import ImageEditModal from '../modals/ImageEditModal';

const SubsiteDetails = () => {
  const location = useLocation();
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;

  const dispatch = useDispatch();
  
  let subsite = JSON.parse(location.state.subsite);


  return (
    <div className="container">
      {subsite.subsiteName}
    </div>
  );
};
export default SubsiteDetails;